module.exports = __webpack_public_path__ + "media/assets/images/flags/pn-88ff525ba1a4085065e31ceb260dc0c2.svg";